import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStoreActions } from 'easy-peasy';
import { getCurrentUser } from '../../services/authService';
import reviewIcon from '../../img/review-icon.svg';
import { useSnackBar } from '../../hooks/snackBarHooks';

const ApprovePost = ({ post, isUserAdmin, isCommunityMod }) => {
  const classes = useStyles();
  const user = getCurrentUser();
  const currentUserId = user.id;
  const { approveOrDeletePost } = useStoreActions((actions) => actions.posts);
  const setToastMessage = useSnackBar();
  const handleDeleteSpamPost = (e) => {
    e.stopPropagation();
    approveOrDeletePost({
      postId: post.id,
      entityId: post.entityId,
      is_spam: true,
      is_active: true,
      is_approved: false,
      setToastMessage: setToastMessage,
    });
  };
  const handleApprovePost = (e) => {
    e.stopPropagation();
    approveOrDeletePost({
      postId: post.id,
      entityId: post.entityId,
      is_spam: false,
      is_active: true,
      is_approved: true,
      setToastMessage: setToastMessage,
    });
  };
  return (
    <React.Fragment>
      {post.isSpamPost &&
        (post.isCommunityOwner || isUserAdmin || isCommunityMod) && (
          <Box display="block" className={classes.main}>
            <Typography
              variant="body1"
              className={classes.textButton}
              onClick={handleDeleteSpamPost}
            >
              Delete
            </Typography>

            <Typography
              variant="body1"
              className={classes.textButton}
              onClick={handleApprovePost}
            >
              Approve
            </Typography>
          </Box>
        )}
      {post.authorId === currentUserId && post.isSpamPost && (
        <Box className={classes.underReview}>
          <img
            src={reviewIcon}
            alt="reviewIcon"
            className={classes.reviewIcon}
          />
          <Typography variant="body1">
            Your post is under review due to potential community guidelines
            violation. Please check back soon.
          </Typography>
        </Box>
      )}
    </React.Fragment>
  );
};
const useStyles = makeStyles((theme) => ({
  main: {
    background: theme.palette.grey[800],
    color: theme.palette.text.primary,
    display: 'flex',
    '& p:first-child': {
      color: 'red',
      borderRight: '1px solid rgba(151, 151, 151, 0.2)',
    },
  },
  textButton: {
    width: '50%',
    textAlign: 'center',
    padding: theme.spacing(2, 2),
    color: '#13c221',
    cursor: 'pointer',
  },
  underReview: {
    background: 'rgba(255,255,255,0.95)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: '10',
    top: theme.spacing(0),
    alignItems: 'center',
    padding: theme.spacing(0, 4),
    display: 'flex',
  },
  reviewIcon: {
    width: '50px',
    marginRight: theme.spacing(2),
  },
}));
export default ApprovePost;
